import { DataLayer } from '@grandvisionhq/analytics';

const stepMapping = {
    lensType: {
        name: 'Vision type',
        id: '100'
    },
    lensTypeVariant: {
        name: 'Vision type variant',
        id: '150'
    },
    prescription: {
        name: 'Prescription details',
        id: '200'
    },
    prescriptionForm: {
        name: 'prescription details form',
        id: '210'
    },
    prescriptionUpload: {
        name: 'Prescription details upload',
        id: '210'
    },
    prescriptionValidation: {
        name: 'Validation',
        id: '300'
    },
    lensPackage: {
        name: 'Lens package',
        id: '400'
    },
    lensAddOn: {
        name: 'Add-ons',
        id: '500'
    },
    lensAddOnVariant: {
        name: 'Add-ons variant',
        id: '550'
    }
};
const pushDataLayerEvent = ({ steps , currentStepIndex , eventType , eventCategory , rx_config  })=>{
    const currentStep = currentStepIndex !== undefined ? steps[currentStepIndex] : undefined;
    const stepDataLayerData = currentStep ? stepMapping[currentStep.name] : undefined;
    const eventData = {
        event: eventType,
        event_category: eventCategory,
        funnel: {
            version: 'AAB3.0',
            type: 'rx_config',
            step_index: stepDataLayerData === null || stepDataLayerData === void 0 ? void 0 : stepDataLayerData.id,
            step_name: stepDataLayerData === null || stepDataLayerData === void 0 ? void 0 : stepDataLayerData.name
        },
        rx_config
    };
    DataLayer.pushEvent(eventData);
};

export { pushDataLayerEvent };
//# sourceMappingURL=events.js.map
